import z from "zod";
import { DormSchema } from "./dorm-cost-dto";
import { ProfessionOptimizedSchema, ProfessionSchema } from "./profession-dto";
import { OpenDaysSchema } from "./open-days-dto";
import { MediaSchema } from "./media-dto";

export enum OrganizationType {
    SPO = 'SPO',
    UNIVERSITY = 'UNIVERSITY'
};

export const EducationalOrganizationsSchema = z.object({
    id: z.string(),
    shortName: z.string(),
    address: z.string().optional().nullable(),
    phone: z.string().optional().nullable(),
    website: z.string().optional().nullable(),
    militaryDepartment: z.boolean(),
    media: z.array(MediaSchema),
    type: z.nativeEnum(OrganizationType),
    longitude: z.number(),
    latitude: z.number(),
    openDays: z.array(OpenDaysSchema),
    dorms: z.array(DormSchema),
    professionsAndSpecializations: z.array(ProfessionSchema),
});
export type EducationalOrganizationsDTO = z.infer<typeof EducationalOrganizationsSchema>;

export const EducationalOrganizationsOptimizedSchema = z.object({
    id: z.string(),
    shortName: z.string(),
    type: z.nativeEnum(OrganizationType),
    longitude: z.number(),
    latitude: z.number(),
    professionsAndSpecializations: z.array(ProfessionOptimizedSchema),
});
export type EducationalOrganizationsOptimizedDTO = z.infer<typeof EducationalOrganizationsOptimizedSchema>;